import React, { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import firebaseConfig from '../firebase/firebaseConfig';
import Layout from '../../component/layout/Layout';

// Initialize Firebase only if not already initialized
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

const Services = () => {
    const [servicesData, setServicesData] = useState({
        wetEndSurveys: null,
        outsourcing: null,
    });

    useEffect(() => {
        const fetchServices = async () => {
            try {
                // Fetch Wet End Surveys document
                const wetEndSurveysDoc = await db.collection('services').doc('4ukPGpjlBTWG4TzcTk7h').get();
                const wetEndSurveys = wetEndSurveysDoc.exists ? wetEndSurveysDoc.data() : null;

                // Fetch Outsourcing document
                const outsourcingDoc = await db.collection('services').doc('Ca85gsagiGL45BvWe7fV').get();
                const outsourcing = outsourcingDoc.exists ? outsourcingDoc.data() : null;

                setServicesData({ wetEndSurveys, outsourcing });
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        };

        fetchServices();
    }, []);

    return (
        <Layout>
            <section id="hero" style={{ backgroundColor: '#0763af' }}>
                <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div className="carousel-item active" style={{ backgroundImage: 'url(img/paper-768x532.jpg)' }}>
                        <div className="carousel-container">
                            <div className="container">
                                <div className="text">
                                    <h2 className="animate__animated animate__fadeInDown" data-aos="fade-down">Services</h2>
                                    <p className="animate__animated animate__fadeInUp"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="shop-detail-section section-padding" style={{ backgroundColor: '#cfe2ff' }}>
                <div className="container" style={{ backgroundColor: '#cfe2ff' }}>
                    <div className="section-title text-center">
                        <h1 style={{ textTransform: 'capitalize' }}>Services</h1>
                        <br />
                    </div>
                    <div className="row" style={{ backgroundColor: 'white' }}>
                        <div className="col-lg-6 col-12 m-auto">
                            <div className="custom-block shop-detail-custom-block">
                                <h3 style={{ color: '#087eca' }}>
                                    <strong>{servicesData.wetEndSurveys?.title}</strong>
                                </h3>
                                <p style={{textAlign:'justify'}}>{servicesData.wetEndSurveys?.description || 'Loading...'}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="shop-image-wrap">
                                <img
                                    src={servicesData.wetEndSurveys?.imageUrl}
                                    className="shop-image img-fluid"
                                    alt={servicesData.wetEndSurveys?.title || 'Wet End Surveys'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="shop-detail-section section-padding section-bg">
                <div className="container">
                    <div className="row" style={{ backgroundColor: 'white' }}>
                        <div className="col-lg-6 col-12">
                            <div className="shop-image-wrap">
                                <img
                                    src={servicesData.outsourcing?.imageUrl}
                                    className="shop-image img-fluid"
                                    alt={servicesData.outsourcing?.title || 'Outsourcing'}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 m-auto">
                            <div className="content">
                                <h3 style={{ color: '#087eca' }}>
                                    <strong>{servicesData.outsourcing?.title}</strong>
                                </h3>
                                <p style={{textAlign:'justify'}}>{servicesData.outsourcing?.description || 'Loading...'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default Services;
